import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "reviews-section",
  id: "reviews"
}
const _hoisted_2 = { class: "reviews-grid" }
const _hoisted_3 = { class: "quote-icon" }
const _hoisted_4 = { class: "stars" }
const _hoisted_5 = { class: "review-text" }
const _hoisted_6 = { class: "review-author" }

import {Quote, Star} from "lucide-vue-next";

import "@/assets/styles/review.css";


export default /*@__PURE__*/_defineComponent({
  __name: 'ReviewView',
  setup(__props) {

const reviews = [
  {
    name: "Familie Schneider",
    text: "Von der Beratung bis zur Umsetzung lief alles professionell und zuverlässig. Unser Garten sieht fantastisch aus.",
  },
  {
    name: "Michael Bauer",
    text: "Saubere Arbeit, pünktlich und sehr freundlich. Besonders die Pflasterarbeiten wurden perfekt umgesetzt.",
  },
  {
    name: "Sandra Keller",
    text: "Wir sind begeistert vom neuen Sichtschutz und der Gestaltung unseres Gartens. Absolute Empfehlung.",
  }
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "reviews-header" }, [
      _createElementVNode("span", { class: "section-badge" }, " Kundenbewertungen "),
      _createElementVNode("h2", null, " Das sagen unsere Kunden "),
      _createElementVNode("p", null, " Zufriedene Kunden und erfolgreiche Projekte stehen bei uns an erster Stelle. ")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(reviews, (review) => {
        return _createElementVNode("div", {
          class: "review-card",
          key: review.name
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(Quote))
          ]),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (star) => {
              return _createVNode(_unref(Star), { key: star })
            }), 64))
          ]),
          _createElementVNode("p", _hoisted_5, " \"" + _toDisplayString(review.text) + "\" ", 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(review.name), 1)
        ])
      }), 64))
    ])
  ]))
}
}

})